import { Integration } from "../classes/integration";
import { AxiosResponse } from 'axios';
import AuthorizedApiClient from 'modules/auth/models/authorizedApiClient';
import { AppResponse } from 'modules/core/interfaces/appResponse';

export class RedirectToIntegrationApi {
    public async getIntegrations(): Promise<Integration[]> {
        const response: AxiosResponse<AppResponse<Integration[]>> =
            await AuthorizedApiClient.get('/Device/integrations');
        const appResponse: AppResponse<Integration[]> = response.data;
    
        if (appResponse.IsSuccess) {
          const integrations: Integration[] = appResponse.Result;
          return integrations;
        } else {
          throw new Error(appResponse.ErrorCodes.join(','));
        }
      }    
}